import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-773749b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "clearfix" }
const _hoisted_3 = {
  key: 0,
  style: {"color":"#4f6bff"}
}
const _hoisted_4 = { style: {"margin-top":"8px"} }
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_file_image_outlined = _resolveComponent("file-image-outlined")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_breadcrumb, { class: "breadcrumb" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_breadcrumb_item, { class: "black" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("customermanagement")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_a_breadcrumb_item, { class: "black" }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: `${_ctx.routerName.customerList}`
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("customerlist")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_breadcrumb_item, { class: "currentrouter" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("newcustomer")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_form, {
      model: _ctx.costomerForm,
      name: "basic",
      "label-col": _ctx.labelCol,
      style: {"width":"50%","margin-top":"20px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          label: _ctx.t('customername'),
          rules: [{ required: true }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              disabled: _ctx.isEdit === '1',
              value: _ctx.costomerForm.organizationName,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.costomerForm.organizationName) = $event))
            }, null, 8, ["disabled", "value"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_a_form_item, {
          label: _ctx.t('customerphotos')
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_a_upload, {
                name: "photos",
                "file-list": _ctx.fileList,
                "onUpdate:fileList": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fileList) = $event)),
                action: _ctx.action,
                data: _ctx.uploadData,
                "list-type": "picture-card",
                onPreview: _ctx.handlePreview,
                onRemove: _ctx.removeImg,
                accept: "image/*",
                onChange: _ctx.imgFileChange
              }, {
                default: _withCtx(() => [
                  (_ctx.fileList.length < 5)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_component_file_image_outlined, { style: {"font-size":"30px"} }),
                        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.t("uploadimages")), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["file-list", "action", "data", "onPreview", "onRemove", "onChange"]),
              _createVNode(_component_a_modal, {
                open: _ctx.previewVisible,
                title: _ctx.previewTitle,
                footer: null,
                onCancel: _ctx.handleCancel
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    alt: "example",
                    style: {"width":"100%"},
                    src: _ctx.previewImage
                  }, null, 8, _hoisted_5)
                ]),
                _: 1
              }, 8, ["open", "title", "onCancel"])
            ])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_a_form_item, {
          label: _ctx.t('workstationmode'),
          rules: [{ required: true }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_radio_group, {
              buttonStyle: 'solid',
              value: _ctx.costomerForm.extension.type,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.costomerForm.extension.type) = $event)),
              name: "radioGroup",
              options: _ctx.options
            }, null, 8, ["value", "options"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_a_form_item, {
          label: _ctx.t('customeraddress'),
          rules: [{ required: true }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: _ctx.costomerForm.extension.location,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.costomerForm.extension.location) = $event)),
              onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleChange($event, 100)))
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_a_form_item, {
          label: _ctx.t('customerremarks')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_textarea, {
              value: _ctx.costomerForm.remark,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.costomerForm.remark) = $event)),
              onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleChange($event, 100)))
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["model", "label-col"]),
    _createElementVNode("div", null, [
      _createVNode(_component_a_button, {
        "html-type": "submit",
        onClick: _ctx.resetForm,
        style: {"margin":"10% 20px 0 40%"}
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t("cancellation")), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_a_button, {
        type: "primary",
        "html-type": "submit",
        onClick: _ctx.submitForm,
        style: {"background-color":"#4f6bff"}
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t("submit")), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}